import React from 'react';
import { ChevronRight, CheckCircle2 } from 'lucide-react';

/* MLS-SVC-NAV-001: left service navigation (Tax "Jurisdictions" interaction; MLS data only).
   Pure navigation — switching never saves, resets or modifies any service. */
export const MlsServiceNav = ({ models, active, onSelect, footer = null }) => (
  <nav className="w-[236px] flex-shrink-0 rounded-2xl border border-slate-200 bg-white p-2.5 self-start sticky top-3 shadow-sm overflow-hidden" data-testid="mls-service-nav">
    <div className="px-1.5 pt-0.5 pb-2">
      <div className="text-[15px] font-bold text-slate-900">Municipal Lien Search</div>
    </div>
    <div className="space-y-1">
      {models.map((m) => {
        const { def, count, status: st } = m;
        const isActive = def.key === active;
        const Icon = def.icon;
        return (
          <button key={def.key} type="button" onClick={() => onSelect(def.key)} aria-current={isActive}
            className={`mls-nav-item relative w-full flex items-center gap-2.5 rounded-xl border px-2.5 py-2 text-left ${isActive
              ? 'border-indigo-300'
              : 'border-transparent hover:bg-slate-50 hover:border-slate-200'}`}
            data-testid={`mls-nav-${def.key}`} data-active={isActive} data-status={st}>
            {isActive && <span className="mls-nav-ink absolute left-0 top-2 bottom-2 w-[3px] rounded-r bg-blue-600" />}
            <span className={`h-8 w-8 grid place-items-center rounded-lg border flex-shrink-0 ${isActive ? 'bg-white border-indigo-200 text-indigo-600' : 'bg-slate-50 border-slate-200 text-slate-500'}`}>
              <Icon className="w-4 h-4" />
            </span>
            <span className="min-w-0 flex-1">
              <span className={`block text-[12.5px] font-bold leading-tight truncate ${isActive ? 'text-indigo-800' : 'text-slate-800'}`}>{def.title}</span>
              <span className="block text-[10.5px] text-slate-500" data-testid={`mls-nav-${def.key}-count`}>
                {m.noneFound ? 'None Found' : `${count} ${count === 1 ? 'entry' : 'entries'}`}
              </span>
            </span>
            {st === 'complete' && <CheckCircle2 className="w-4 h-4 text-emerald-500 flex-shrink-0" data-testid={`mls-nav-${def.key}-ok`} />}
            {st === 'in_progress' && <span className="h-2 w-2 rounded-full bg-amber-400 flex-shrink-0" data-testid={`mls-nav-${def.key}-dot`} />}
            <ChevronRight className={`w-4 h-4 flex-shrink-0 ${isActive ? 'text-indigo-500' : 'text-slate-300'}`} />
          </button>
        );
      })}
    </div>
    {footer && <div className="mt-2 pt-2 border-t border-slate-100" data-testid="mls-service-nav-footer">{footer}</div>}
    <div className="mls-side-art" aria-hidden="true" data-testid="mls-service-nav-art">
      <img src="/assets/mls-sidebar-art.png" alt="" draggable="false" />
    </div>
  </nav>
);
